import api from './api'

export const iotDevicesApi = {
  getByTenant: (tenantId) =>
    api.get(`/tenants/${tenantId}/iot-devices`).then((r) => r.data),

  /** Estado do cliente MQTT no EMQX (username = DevEUI). Só para devices tipo MQTT. */
  getEmqxClientStatus: (deviceId) =>
    api.get(`/iot-devices/${encodeURIComponent(deviceId)}/emqx-client`).then((r) => r.data),

  checkDevEui: (devEui) =>
    api.get('/iot-devices/check-deveui', { params: { devEui } }).then((r) => r.data),

  create: (tenantId, payload) =>
    api.post(`/tenants/${tenantId}/iot-devices`, payload).then((r) => r.data),

  remove: (id) =>
    api.delete(`/iot-devices/${encodeURIComponent(id)}`).then((r) => r.data),

  update: (id, payload) =>
    api.put(`/iot-devices/${encodeURIComponent(id)}`, payload).then((r) => r.data),

  enableWebDevice: (devEui) =>
    api.post(`/iot-devices/${encodeURIComponent(devEui)}/web-device/enable`).then((r) => r.data),

  regenerateWebDeviceToken: (devEui) =>
    api.post(`/iot-devices/${encodeURIComponent(devEui)}/web-device/regenerate-token`).then((r) => r.data),

  disableWebDevice: (devEui) =>
    api.post(`/iot-devices/${encodeURIComponent(devEui)}/web-device/disable`).then((r) => r.data),

  // Destinatários de alarme por WhatsApp
  getAlarmRecipients: (id) =>
    api.get(`/iot-devices/${encodeURIComponent(id)}/alarm-recipients`).then((r) => r.data),

  setAlarmRecipients: (id, tenantUserIds) =>
    api.post(`/iot-devices/${encodeURIComponent(id)}/alarm-recipients`, { tenantUserIds }).then((r) => r.data),

  getAlarmRecipientCandidates: (tenantId) =>
    api.get(`/tenants/${tenantId}/iot-alarm-recipient-candidates`).then((r) => r.data),
}
